import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Home } from './pages/Home';
import { createTheme, ThemeProvider } from '@mui/material';
import { Apps } from './pages/Apps';
import ProtectedRoute from './components/ProtectedRoute';
import { Login } from './pages/Login';
import { NotFound } from './pages/NotFound';
import { CrearAcceso } from './pages/CrearAcceso';
import { AnularAcceso } from './pages/AnularAcceso';
import { IngresoGarita } from './pages/IngresoGarita';
import { Perfil } from './pages/Perfil';
import { HistorialAcceso } from './pages/HistorialAcceso';
import { EgresoGarita } from './pages/EgresoGarita';
import { EstadoCuenta } from './pages/EstadoCuenta';
import { PagosRecibidos } from './pages/PagosRecibidos';
import { FotosPruebas } from './pages/FotosPruebas';
import { Reservas } from './pages/Reservas3/Reservas';
import { Reservas as Reservas2 } from './pages/Reservas2/Reservas';
import { LecturaAgua } from './pages/LecturaAgua';
import { HistoricoLecturaAgua } from './pages/HistoricoLecturaAgua';
import { ControlInmuebles } from './pages/ControlInmuebles';
import { Publicaciones } from './pages/Publicaciones';
import { PublicacionesPublicas } from './pages/PublicacionesPublicas';
import { Encuestas } from './pages/Encuestas';
import { Incidentes } from './pages/Incidentes';
import { Incidentes as Incidentes2 } from './pages/Incidentes2';
import { HistorialReserva } from './pages/HistorialReservas';
import { CargosVsAbonos } from './pages/CargosVsAbonos';
import { Sponsor } from './pages/Sponsor';
import { AbonosPorTipo } from './pages/AbonosPorTipo';
import { HistorialIncidentes } from './pages/HistorialIncidenctes';
import { Notificaciones } from './pages/Notificaciones';
import { HistorialReservaAdmin } from './pages/HistorialReservasAdmin';
import { CrearAccesoFrecuente } from './pages/CrearAccesoFrecuente';
import { HistorialAccesoFrecuentes } from './pages/HistorialAccesoFrecuentes';
import { Proveedores } from './pages/Proveedores';
import { PagosInmuebles } from './pages/PagosInmuebles';



function App() {
  




  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={<Navigate to="/login" replace />}
          />
          <Route path="/login" element={<Login />} />

          <Route path="/home" element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }>
            <Route path="" element={<Apps />} />
            <Route path="crear-acceso" element={<CrearAcceso />} />
            <Route path="accesos-frecuentes" element={<HistorialAccesoFrecuentes />} />
            <Route path="crear-acceso-frecuente" element={<CrearAccesoFrecuente />} />
            <Route path="anular-acceso" element={<AnularAcceso />} />
            <Route path="ingreso-garita" element={<IngresoGarita />} />
            <Route path="egreso-garita" element={<EgresoGarita />} />
            <Route path="perfil-usuario" element={<Perfil />} />
            <Route path="historial-accesos" element={<HistorialAcceso />} />
            <Route path="estado-cuenta" element={<EstadoCuenta />} />
            <Route path="pagos-recibidos" element={<PagosRecibidos />} />
            <Route path="fotos-pruebas" element={<FotosPruebas />} />
            <Route path="reservas" element={<Reservas />} />
            <Route path="reservas2" element={<Reservas2 />} />
            <Route path="lectura-agua" element={<LecturaAgua />} />
            <Route path="historico-agua" element={<HistoricoLecturaAgua />} />
            <Route path="control-inmuebles" element={<ControlInmuebles />} />
            <Route path="publicaciones" element={<Publicaciones />} />
            <Route path="notificaciones" element={<Notificaciones />} />
            <Route path="encuestas" element={<Encuestas />} />
            <Route path="crear-incidente" element={<Incidentes2 />} />
            <Route path="historial-reserva" element={<HistorialReserva />} />
            <Route path="cargos-abonos" element={<CargosVsAbonos />} />
            <Route path="sponsor" element={<Sponsor />} />
            <Route path="ingresos-tipo" element={<AbonosPorTipo />} />
            <Route path="historial-incidentes" element={<HistorialIncidentes />} />
            <Route path="reservas-admin" element={<HistorialReservaAdmin />} />
            <Route path="proveedores" element={<Proveedores />} />
            <Route path="pagos-inmuebles" element={<PagosInmuebles />} />


            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="instrucciones" element={<PublicacionesPublicas />} />
          <Route path="*" element={<NotFound />} />

        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

const theme = createTheme({
  typography: {
    fontFamily: [
      'Oswald',
      'Source Sans Pro',
      'sans-serif',
    ].join(','),
  },

  palette: {
    primary: {
      main: '#013467',
    },
    secondary: {
      main: '#FFCC00',
    },
    info: {
      main: '#000000',

    }
  },

});

export default App;
